<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import TwOverlay from '../components/TwOverlay';
import Edit from '../components/schedules/Edit';
import SnackBar from '../components/schedules/SnackBar';
import TwConfirmDialog from '../components/TwConfirmDialog';
import router from '../router';
import Format from '../components/schedules/format';

export default {
  name: 'EditSchedules',
  mixins: [
    Format,
  ],
  data() {
    return {
      schedule: {
        minutes: '',
        hours: '',
        weekdays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        values: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        isSubmit: true,
        isEdit: false,
        subs: [],
        sub: '',
        scheduleId: null,
      },
      snackbar: {
        snackbar: false,
        y: 'top',
        x: null,
        color: '',
        mode: 'multi-line',
        timeout: 6000,
        text: '',
      },
    };
  },
  components: {
    TwOverlay,
    TwConfirmDialog,
    Edit,
    SnackBar,
  },
  computed: {
    ...mapState({
      editSchedules: state => state.schedules.schedules,
      deletedSchedule: state => state.schedules.deletedSchedule,
    }),
    ...mapGetters({
      xmlChannels: 'schedules/getXmlChannelsForEdit',
      subchannels: 'schedules/getSubchannels',
    }),
  },
  methods: {
    ...mapActions({
      setBreadcrumbs: 'nav/setBreadcrumbs',
      deleteSchedules: 'schedules/deleteSchedule',
      updateSchedules: 'schedules/updateSchedules',
      getSchedules: 'schedules/getSchedules',
    }),
    goBackToOverview() {
      router.push({ name: 'Schedules' });
    },
    prepareScheduleValuesForEdit(sub, schedule) {
      const hoursMinAndWeekdaysArray = Format.prepareScheduleValuesForEdit(
        schedule.scheduledTimes,
        this.schedule.values,
      );
      this.schedule = {
        ...this.schedule,
        hours: hoursMinAndWeekdaysArray[0],
        minutes: hoursMinAndWeekdaysArray[1],
        weekdays: hoursMinAndWeekdaysArray[2],
        subs: this.subchannels,
        sub,
        scheduleId: schedule.scheduleId,
        isEdit: true,
        isSubmit: false,
      };
    },
    deleteSchedule(scheduleId) {
      this.deleteSchedules(scheduleId).then(() => {
        this.updateSchedules(this.$route.params.webservice);
        this.getSchedules().then(() => {
          this.snackbar.color = 'success ';
          this.snackbar.timeout = 4000;
          this.snackbar.text = `schedule with id: ${scheduleId} deleted`;
          this.snackbar.snackbar = true;
        });
      });
    },
    confirmDelete(scheduleId) {
      this.schedule.scheduleId = scheduleId;
      this.$refs.confirmChannelScheduleDelete.open();
    },
    cancelDelete() {
      this.schedule.scheduleId = null;
    },
  },
  created() {
    if (this.editSchedules.items.length === 0 || this.editSchedules.items.length === undefined) {
      this.updateSchedules(this.$route.params.webservice);
    }
    this.setBreadcrumbs({
      breadcrumbs: [
        { text: this.$t('menu.schedules.pages.schedules'), to: '', disabled: true },
      ],
      title: this.$t('menu.schedules.title'),
    });
  },
};
</script>

<template>
  <v-container class="schedules">
    <v-layout class="row wrap schedules__list">
      <tw-overlay :visible="editSchedules.loading"></tw-overlay>
      <tw-confirm-dialog
        title="Are you sure?"
        description="This will delete the schedule - are you sure?"
        ref="confirmChannelScheduleDelete"
        @confirm="deleteSchedule(schedule.scheduleId)"
        @cancel="cancelDelete"
      />
      <v-progress-circular
        v-if="editSchedules.loading"
        class="schedules__loading"
        indeterminate
      ></v-progress-circular>
      <v-flex xs12 wrap>
        <v-layout class="row justify-space-between">
          <v-flex xs4 md2 wrap>
            <h2 class="mb-2 mt-4">
              {{ xmlChannels.webservice }}</h2>
          </v-flex>
          <v-flex xs6 md2 wrap>
            <v-btn
              color="info"
              @click="goBackToOverview"
            >
              return to overview
            </v-btn>
          </v-flex>
        </v-layout>
        <snackBar :snackbar.sync="snackbar"/>
        <edit :schedule.sync="schedule" :snackbar.sync="snackbar" :subchannels="subchannels"/>
        <v-card xs12 wrap>
          <v-container fluid grid-list-xs>
            <v-layout row wrap xs12>
              <v-flex
                v-for="scheduledTime in xmlChannels.schedules"
                :key="scheduledTime.scheduleId"
                schedules__card
                xs12
                wrap
              >
                <v-layout row wrap xs12 align-center>
                  <v-flex xs12 md10>
                    {{ scheduledTime.scheduledTimes }}
                  </v-flex>
                  <v-flex xs12 md2>
                    <v-btn
                      label="editSchedule"
                      color="info"
                      @click="prepareScheduleValuesForEdit(null,scheduledTime)"
                    >
                      Edit
                    </v-btn>
                    <v-btn
                      label="deleteSchedule"
                      color="error"
                      @click="confirmDelete(scheduledTime.scheduleId)"
                    >
                      Delete
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-divider/>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 wrap>
                <v-card
                  v-if="
                    xmlChannels.subChannels !== undefined &&
                    xmlChannels.subChannels.length !== 0
                  "
                >
                  <v-card-title xs12 wrap>
                    <v-flex
                      v-for="subChannel in xmlChannels.subChannels"
                      :key="subChannel.id"
                      schedules__card
                      shrink
                      xs12
                      wrap
                    >
                      <h4 class="d-inline-block">{{ subChannel.name }}</h4>
                      <v-layout
                        v-for="time in subChannel.schedules"
                        :key="time.scheduleId"
                        row
                        xs12
                        wrap
                        align-center
                      >
                        <v-flex>
                          <v-layout row xs12 wrap align-center>
                            <v-flex xs12 md10 wrap>
                              {{ time.scheduledTimes }}
                            </v-flex>

                            <v-flex xs12 md2 wrap>
                              <v-btn
                                label="editSubBtn"
                                color="info"
                                @click="prepareScheduleValuesForEdit(subChannel.name, time)"
                              >
                                Edit
                              </v-btn>
                              <v-btn
                                label="deleteSubSchedules"
                                color="error"
                                @click="confirmDelete(time.scheduleId)"
                              >
                                Delete
                              </v-btn>
                            </v-flex>
                          </v-layout>
                          <v-divider/>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-title>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.schedules {
  position: relative;

  &__list {
    min-height: 150px;
  }

  &__card {
    min-width: 12.5%;
  }

  &__refresh {
    float: right;
    margin-top: 15px;
  }

  &__loading {
    position: absolute;
    z-index: 20;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/EditSchedules.vue